module.exports = __webpack_public_path__ + "static/media/Caveman.24f66f3a.jpg";